import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Investors\UserManagementController::index
* @see app/Http/Controllers/Investors/UserManagementController.php:24
* @route '//app.finesthub.de/users-management'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '//app.finesthub.de/users-management',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Investors\UserManagementController::index
* @see app/Http/Controllers/Investors/UserManagementController.php:24
* @route '//app.finesthub.de/users-management'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\UserManagementController::index
* @see app/Http/Controllers/Investors/UserManagementController.php:24
* @route '//app.finesthub.de/users-management'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Investors\UserManagementController::index
* @see app/Http/Controllers/Investors/UserManagementController.php:24
* @route '//app.finesthub.de/users-management'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Investors\UserManagementController::destroyAccess
* @see app/Http/Controllers/Investors/UserManagementController.php:63
* @route '//app.finesthub.de/users-management/{account}/access'
*/
export const destroyAccess = (args: { account: string | number | { id: string | number } } | [account: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroyAccess.url(args, options),
    method: 'delete',
})

destroyAccess.definition = {
    methods: ["delete"],
    url: '//app.finesthub.de/users-management/{account}/access',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Investors\UserManagementController::destroyAccess
* @see app/Http/Controllers/Investors/UserManagementController.php:63
* @route '//app.finesthub.de/users-management/{account}/access'
*/
destroyAccess.url = (args: { account: string | number | { id: string | number } } | [account: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { account: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { account: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            account: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        account: typeof args.account === 'object'
        ? args.account.id
        : args.account,
    }

    return destroyAccess.definition.url
            .replace('{account}', parsedArgs.account.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\UserManagementController::destroyAccess
* @see app/Http/Controllers/Investors/UserManagementController.php:63
* @route '//app.finesthub.de/users-management/{account}/access'
*/
destroyAccess.delete = (args: { account: string | number | { id: string | number } } | [account: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroyAccess.url(args, options),
    method: 'delete',
})

const UserManagementController = { index, destroyAccess }

export default UserManagementController